import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import type { QuizAttempt } from "@/react/types/QuizAttempt";
import type { QuizCommunityMember } from "../../QuizResults";
import { QuizResult } from "./QuizResult";
import { QuizResultSummary } from "./QuizResultSummary";

interface ContentProps {
  attempt: QuizAttempt;
  setIsSubmitEnabled: (value: boolean) => void;
  student: QuizCommunityMember;
}
export const Content = ({
  attempt,
  student,
  setIsSubmitEnabled,
}: ContentProps) => {
  const { watch } = useFormContext();
  const { result } = watch();

  useEffect(() => {
    setIsSubmitEnabled(result === "passed" || result === "failed");
  }, [result, setIsSubmitEnabled]);
  return (
    <div className="flex flex-col-reverse overflow-hidden sm:flex-row sm:items-start">
      <QuizResult attempt={attempt} />
      <QuizResultSummary
        attempt={attempt}
        student={student}
        resultValue={result}
      />
    </div>
  );
};
